import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//引入vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
//引入重置样式
import '../src/assets/style/reset.css'
import './assets/fonts/iconfont.css'
// api
import apicode from './apis/apicode'
Vue.prototype.$apicode = apicode

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

Vue.config.productionTip = false

// import axios from 'axios'
// axios.defaults.baseURL = '/api'

// Vue.prototype.$axios = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
